import{unstable_createChainedFunction as _0x37edd7}from'@mui/utils';export default _0x37edd7;